import * as yup from 'yup';
import { sharedApeironFields } from '../shared/sharedApeironSchema';

export const bikeApeironSchemaBuilder = (
  firstDriverAdditionalPremiumAge,
  secondDriverAdditionalPremiumAge,
  firstDriverAdditionalPremiumLicenseYears,
  secondDriverAdditionalPremiumLicenseYears,
  legalEntity,
  secondDriver,
  discountEntity,
  vehicleType
) =>
  yup.object({
    ...sharedApeironFields(
      firstDriverAdditionalPremiumAge,
      secondDriverAdditionalPremiumAge,
      firstDriverAdditionalPremiumLicenseYears,
      secondDriverAdditionalPremiumLicenseYears,
      legalEntity,
      secondDriver,
      discountEntity,
      vehicleType
    ),
    license_cat: yup.string().required(),
  });

export default bikeApeironSchemaBuilder;
